import React, { useState } from "react";

import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";
import { httpsCallable, getFunctions } from "firebase/functions";
import { db } from "../services/firebase";
import bcrypt from "bcryptjs";
import { v4 as uuidv4 } from "uuid";
import { useBuyer } from "../contexts/BuyerContext";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { useAlert } from "../contexts/AlertContext";
import Logo from "../JMIlogo.png";

const Register = () => {
  const { updateBuyer } = useBuyer();
  const [mobile, setMobile] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpId, setOtpId] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const showAlert = useAlert();

 const sendOtp = async () => {
    if (mobile.length !== 10 || isNaN(mobile)) {
      await showAlert("Enter a valid 10-digit mobile number");
      return;
    }

    setLoading(true);
    try {
      // Check if already registered
      const q = query(collection(db, "buyers"), where("mobile", "==", mobile));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        await showAlert("This mobile number is already registered.");
        return;
      }

      // Trigger Cloud Function
      const functions = getFunctions(undefined, "us-central1");
      const sendOTP = httpsCallable(functions, "sendOTP");

      const result = await sendOTP({
        mobile,
        useCase: "REGISTRATION",
      });

      setOtpId(result.data.otpId);
      setOtpSent(true);
      await showAlert(`OTP sent to +91 ${mobile} successfully.`);
    } catch (err) {
      console.error("Error sending OTP:", err);
      await showAlert(err.message || "Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  // Verify OTP and Register Buyer
   const verifyOtpAndRegister = async () => {
    if (!otp || !password || !confirmPass) {
      await showAlert("Please fill all fields");
      return;
    }

    if (password !== confirmPass) {
      await showAlert("Passwords do not match");
      return;
    }

    setLoading(true);
    try {
      const functions = getFunctions(undefined, "us-central1");
      const verifyOTP = httpsCallable(functions, "verifyOTP");

      const verifyResult = await verifyOTP({
        otpId: otpId || `+91${mobile}_JMI_REGISTRATION_OTP`,
        otp: otp.trim(),
        mobile,
        useCase: "REGISTRATION",
      });

      if (!verifyResult.data.success) {
        await showAlert("OTP verification failed. Please try again.");
        return;
      }

      const buyerId = "BUYER-" + uuidv4().split("-")[0].toUpperCase();
      const passwordHash = await bcrypt.hash(password, 10);

      const buyerData = {
        buyerId,
        mobile,
        createdAt: new Date(),
        passwordHash,
        status: "pending",
      };

      await setDoc(doc(db, "buyers", buyerId), buyerData);

      updateBuyer({
        buyerId,
        mobile,
        registrationStatus: false,
      });

      await new Promise((resolve) => setTimeout(resolve, 100));
      await showAlert("You registered successfully!");
      nav("/buyerregistration", { replace: true });
    } catch (err) {
      console.error("Registration error:", err);
      if (err.message.includes("expired")) {
        await showAlert("OTP has expired. Please request a new one.");
        setOtpSent(false);
      } else if (err.message.includes("Invalid")) {
        await showAlert("Invalid OTP. Please check and try again.");
      } else {
        await showAlert(
          err.message ||
            "Something went wrong during verification. Please try again.",
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <h1 className="title"><img src={Logo} className="logo" alt="logo" /></h1>

      <div className="login-box">
        <h2>Registration</h2>

        <label>Mobile</label>
        <input
          type="tel"
          maxLength="10"
          placeholder="Enter Mobile Number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
          disabled={otpSent}
        />

        {!otpSent ? (
          <button className="login-btn" onClick={sendOtp} disabled={loading}>
            {loading ? "Generating OTP..." : "Send OTP"}
          </button>
        ) : (
          <>
            <label>OTP</label>
            <input
              type="text"
              placeholder="Enter OTP (sent via WhatsApp)"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <label>Password</label>
            <input
              type="password"
              placeholder="Enter password"
              value={password}
              minLength="6"
              onChange={(e) => setPassword(e.target.value)}
            />

            <label>Confirm Password</label>
            <input
              type="password"
              placeholder="Confirm password"
              value={confirmPass}
              minLength="6"
              onChange={(e) => setConfirmPass(e.target.value)}
            />

            <button
              className="login-btn"
              onClick={verifyOtpAndRegister}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify & Register"}
            </button>
          </>
        )}
      </div>

      <p className="register-link">
        Already have an account?{" "}
        <span
          onClick={() => nav("/login")}
        >
          Login
        </span>
      </p>

     <p className="support">
        <img src="/whatsapp.svg" alt="whatsapp" className="whatsapp-icon" />
        <span onClick={() => window.open("https://wa.me/918917412728", "_blank")}> Need help? </span>Contact Support
      </p>

      {/* Hidden container (in case you keep reCAPTCHA for other flows) */}
      <div id="recaptcha-container"></div>
    </div>
  );
};

export default Register;